/**
 * Contact Popup Functionality
 */
const initContactPopup = () => {
    console.log('Initializing Popup Functionality');
    const popup = document.getElementById('contact-popup');
    if (!popup) {
        console.warn('Contact popup element not found!');
        return;
    }

    const closeBtn = popup.querySelector('.contact-popup__close');
    const overlay = popup.querySelector('.contact-popup__overlay');

    const openPopup = (e) => {
        console.log('Opening popup...');
        if (e) e.preventDefault();
        popup.classList.add('active');
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    };

    const closePopup = () => {
        popup.classList.remove('active');
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    };

    // Use event delegation for triggers
    document.addEventListener('click', (e) => {
        // Target explicit data attribute OR links pointing to contact
        const trigger = e.target.closest('[data-popup="contact"]') || e.target.closest('a');
        
        if (trigger) {
            const href = trigger.getAttribute('href');
            const hasPopupAttr = trigger.hasAttribute('data-popup') && trigger.getAttribute('data-popup') === 'contact';
            const isContactLink = href && (href.includes('/contact/') || href.includes('/contact-us'));

            if (hasPopupAttr || isContactLink) {
                openPopup(e);
            }
        }
    });

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);

    // Close on ESC
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.classList.contains('active')) {
            closePopup();
        }
    });
};

/**
 * Welcome Popup Functionality
 */
const initWelcomePopup = () => {
    const welcomePopup = document.getElementById('reim-welcome-popup');
    if (!welcomePopup) return;

    // Check if user dismissed it within the last 24 hours (1 day)
    const dismissedTime = localStorage.getItem('reim-welcome-popup-dismissed-time');
    const ONE_DAY_MS = 24 * 60 * 60 * 1000;
    if (dismissedTime && (Date.now() - parseInt(dismissedTime, 10) < ONE_DAY_MS)) {
        return;
    }

    const closeBtn = welcomePopup.querySelector('.reim-welcome-popup-close');
    const dismissBtns = welcomePopup.querySelectorAll('.reim-welcome-popup-dismiss');
    
    const showPopup = () => {
        welcomePopup.style.display = 'flex';
        // Trigger reflow for transition
        void welcomePopup.offsetWidth;
        welcomePopup.classList.add('active');
        document.body.style.overflow = 'hidden';
    };

    const dismissPopup = () => {
        welcomePopup.classList.remove('active');
        document.body.style.overflow = '';
        localStorage.setItem('reim-welcome-popup-dismissed-time', Date.now().toString());
        
        // Hide after transition completes
        setTimeout(() => {
            welcomePopup.style.display = 'none';
        }, 400);
    };

    // Open popup after a short delay (e.g. 1500ms)
    setTimeout(showPopup, 1500);

    // Close events
    if (closeBtn) {
        closeBtn.addEventListener('click', dismissPopup);
    }

    dismissBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            const href = btn.getAttribute('href');
            if (href === '#' || href === 'javascript:void(0);' || !href) {
                e.preventDefault();
            }
            dismissPopup();
        });
    });

    // Close on overlay click
    welcomePopup.addEventListener('click', (e) => {
        if (e.target === welcomePopup) {
            dismissPopup();
        }
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && welcomePopup.classList.contains('active')) {
            dismissPopup();
        }
    });
};

// Run on DOM ready
const initAllPopups = () => {
    initContactPopup();
    initWelcomePopup();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPopups);
} else {
    initAllPopups();
}
